import { useMemo } from "react";
import { useSelector } from "react-redux";

const useCartDetails = () => {
  const { cartItems, addressId, zipCode } = useSelector(
    (state) => state.userCart
  );

  // GET TOTAL UNIQUE ITEMS COUNT
  const getTotalUniqueItemsCount = () => cartItems?.length || 0;

  // GET TOTAL ITEMS COUNT
  const getTotalItemsCount = () =>
    cartItems &&
    cartItems.length > 0 &&
    cartItems?.reduce((acc, item) => acc + item.quantity, 0);

  // GET UPDATED CART DETAILS
  const getCartDetails = () => cartItems || [];

  // const getActiveCartProducts = () => {
  //   return cartItems?.filter((item) => item?.product?.websiteActive);
  // };
  const getActiveCartProducts = () => {
    return cartItems
  };

  // GET COUNT OF PRODUCT ADDED IN CART BY PRODUCT ID
  const getCountByProductId = ({ productId }) => {
    if (!cartItems || cartItems.length === 0) {
      return 0;
    }

    const quantity =
      cartItems.find((item) => item.productId === Number(productId))
        ?.quantity || 0;

    return quantity;
  };

  //GET USER CURRENT ADDRESS ID
  const getAddressId = addressId || null;

  const userSelectedZipCode = zipCode || null;

  const isAllProductsInActive = useMemo(() => {
    return (
      cartItems?.length > 0 &&
      cartItems.every(({ product }) => product?.websiteActive === false)
    );
  }, [cartItems]);

  return {
    getTotalUniqueItemsCount,
    getCartDetails,
    getCountByProductId,
    getTotalItemsCount,
    getAddressId,
    userSelectedZipCode,
    isAllProductsInActive,
    getActiveCartProducts,
  };
};

export default useCartDetails;
